var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nr_container_content business_page_tabs" },
    [
      _c(
        "v-card",
        [
          _c(
            "v-tabs",
            {
              attrs: { "background-color": "white", white: "" },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            _vm._l(_vm.items, function (item) {
              return _c("v-tab", { key: item.tab }, [
                _vm._v("\n        " + _vm._s(item.tab) + "\n      "),
              ])
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              staticClass: "mt-60",
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            _vm._l(_vm.items, function (item) {
              return _c(
                "v-tab-item",
                { key: item.tab },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    _vm._l(item.content, function (el) {
                      return _c(
                        "v-card-text",
                        { staticClass: "my-0 my-sm-5" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12 col-md-4" }, [
                              !el.download
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "business_page_tabs__img d-flex align-items-center justify-content-center",
                                    },
                                    [_c("img", { attrs: { src: el.img } })]
                                  )
                                : el.download
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "business_page_tabs__img d-flex align-items-center justify-content-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "business_page_tabs__file position-relative h-100 d-flex flex-column  justify-content-between",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "type_file" },
                                            [_vm._v("PDF")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "download_file w-100 d-flex align-items-center justify-content-between",
                                            },
                                            [
                                              _c("span", [_vm._v("Скачать")]),
                                              _vm._v(" "),
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "30",
                                                    height: "30",
                                                    viewBox: "0 0 30 30",
                                                    fill: "none",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M26.25 18.75V23.75C26.25 24.413 25.9866 25.0489 25.5178 25.5178C25.0489 25.9866 24.413 26.25 23.75 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75V18.75",
                                                      stroke: "white",
                                                      "stroke-width": "2",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M8.75 12.5L15 18.75L21.25 12.5",
                                                      stroke: "white",
                                                      "stroke-width": "2",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M15 18V1",
                                                      stroke: "white",
                                                      "stroke-width": "2",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("a", {
                                            staticClass:
                                              "position-absolute t-0 l-0 w-100 h-100 zi-1",
                                            attrs: { href: el.download },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 col-md-8" }, [
                              _c(
                                "div",
                                { staticClass: "business_page_tabs__title" },
                                [_vm._v(_vm._s(el.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "business_page_tabs__descr",
                                  domProps: { innerHTML: _vm._s(el.descr) },
                                },
                                [
                                  _vm._v(
                                    "\n\n                  " +
                                      _vm._s(el.descr) +
                                      "\n\n                  "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "business_page_tabs__buy " },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn_red",
                                      on: {
                                        click: function ($event) {
                                          return _vm.btn_buy(el)
                                        },
                                      },
                                    },
                                    [_vm._v("Купить")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }